<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Modifier un utilisateur</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  

            <div class="col-md-7 fixed-top m-auto mrg-top-70" v-if="SetPermission!=null">
                <b-alert
                    :show="alert.dismissCountDown"
                    dismissible :variant="SetPermission? 'danger' : 'success'"
                    @dismissed="[alert.dismissCountDown=0,SetPermission=null,deleteUser=null]"
                    @dismiss-count-down="countDownChanged">
                    <div class="text-center m-auto pl-4" :class="SetPermission? 'text-danger' : 'text-dark'" > 
                        <span v-if="!SetPermission" class="lead"> 
                            <span v-if="deleteUser">
                                   Cet utilisateur a été supprimé avec succès
                            </span >
                            <span v-else>
                                Les permissions ont été mises à jour avec succès. 
                            </span>
                        
                        </span>
                        <span v-else class="lead"> {{errormsg}} </span>
                    <br><hr>
                    <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                    </div>
                </b-alert>
            </div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->
                        <div class="col-md-10 ml-auto mr-auto" v-show="stateForm != 1">
                            <form action="">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Sélectionnez l'utilisateur à modifier : </label>
                                            <select class="form-control" v-model="user_selected" required>
                                                <option v-bind:value="null" selected>Choisissez un utilisateur</option>
                                                <option v-for="adherent in adherents" v-bind:value="adherent" v-bind:key="adherent.id">
                                                    {{adherent.title}} {{adherent.firstname}} {{adherent.lastname}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mrg-top-5">
                                    <button type="button" class="btn btn-primary" v-bind:disabled="user_selected == null" v-on:click="next">Suivant</button>
                                </div>
                            </form>
                        </div>
                        <div class="col-md-10 ml-auto mr-auto" v-show="stateForm == 1">
                              
                            <form @submit.prevent="add">
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label>Intitulé<span class="text-danger">*</span></label>
                                            <select v-model="title" class="form-control" required>
                                                <option disabled value=null>Choisir...</option>
                                                <option>Mme.</option>
                                                <option>M.</option>
                                                <option>CUMA</option>
                                                <option>EARL</option>
                                                <option>SCEA</option>
                                                <option>GAEC</option>
                                                <option>SAS</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Nom<span class="text-danger">*</span></label>
                                            <input v-model="lastname" 
                                                    type="text" 
                                                    name="Nom"
                                                    @keypress="check_input($event)"
                                                    
                                                    placeholder="Entrer le nom de famille" 
                                                    class="form-control" 
                                                    minlength="1" 
                                                    maxlength="255"
                                                    required  >
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Prénom<span v-show='required.firstname' class="text-danger" >*</span></label>
                                           <input v-model="firstname" 
                                                    type="text" 
                                                    name="Prénom" 
                                                    @keypress="check_input($event)"
                                                    placeholder="Entrer le prénom" 
                                                    class="form-control" 
                                                    minlength="1" 
                                                    maxlength="255"
                                                    :required='required.firstname'>
                                        </div>
                                    </div>
                                </div>
<!-- ########################################################## -->
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Adresse email<span class="text-danger">*</span></label>
                                             <input v-model="email" type="email" placeholder="Entrer son email" class="form-control"  pattern="[^@\s]+@[^@\s]+\.[^@\s]+" size="30" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Télephone fixe<span v-show="required.tel ? 'text-danger' : ''"  class="text-danger">*</span></label>
                                            <input v-model="tel" 
                                                    type="tel" 
                                                    name="Télephone fixe"
                                                    @keypress="check_phone_number($event)"
                                                    
                                                    placeholder="Entrer son numéro fixe" 
                                                    class="form-control"
                                                    minlength="10" 
                                                    maxlength="30"
                                                    :required="required.tel">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Télephone mobile<span v-show="required.mobile ? 'text-danger' : ''" class="text-danger">*</span></label>
                                             <input v-model="mobile"
                                                    type="tel" 
                                                    name="Télephone mobile"
                                                    @keypress="check_phone_number($event)"
                                                    placeholder="Entrer son numéro mobile" 
                                                    class="form-control"
                                                    minlength="10" 
                                                    maxlength="30"
                                                    :required="required.mobile">
                                        </div>
                                    </div>
                                </div>
                                <div class="row mrg-top-5">
                                    
                                        <div class="col-md-6 text-left">
                                            <b-button class="btn btn-icon btn-rounded" @click="open_permission_modal(user_selected)" style="background-color: rgb(175, 214, 255);">
                                       Modifier les permissions <img :src="require('../../assets/user-lock-solid.svg')" contain height="15" />
                                            </b-button>
                                            
                                        </div>
                                        <div class="col-md-6 text-right" >
                                            
                                    <button type="reset" class="btn btn-default" v-on:click="previous()">Annuler</button>
                                    <button type="submit" class="btn btn-primary">Modifier</button>
                                        </div>
                                </div>
                                <div class="alert alert-danger" role="alert" v-if="error">
                                            Impossible d'éditer l'utilisateur ! Veuillez contacter KEMTAG
                                     <i class="ti-close float-right mt-1" @click="error = false"></i>
                                </div> 
                            </form>
                            

<!-- ########################################################## -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <b-modal ref="permission_popup" hide-footer centered title="Permission"  size="xl">
            <v-user-permission
                :selected_user="user_selected"
                :action="action"
                @user-permission-done = "close_permission_modal"
            >

        </v-user-permission>
        </b-modal>

    </div>
</template>

<script>

    import api from "../../config/_api";
    import { mapGetters } from 'vuex';
    import UserPermission from "../../components/UserPermission.vue";

    export default {
        name: "Edit",
        components:{
            'v-user-permission': UserPermission,
        },
        data () {
            return {
                action : "editer",
                stateForm: 0,
                user_selected: null,
                code: "",
                title: "",
                firstname: "",
                lastname: "",
                email: "",
                tel: "",
                mobile: "",
                role_id :"",
                error: false, // initialiser l'objet error {pour la fonction alerte}
                errormsg : "",
                required : {
                    mobile : true, 
                    tel :true ,
                    firstname : true
                },
                SetPermission : null,
                deleteUser : null , 
                alert : {
                        dismissSecs: 10,
                        dismissCountDown: 0,
                },
            }
        },
        computed: {
            ...mapGetters({
                adherents: 'adherents/adherents'
            }),
        },
        mounted() {
            //this.$store.dispatch('adherents/getAdherents');
            
            this.$store.dispatch('adherents/getUtilisateurs');
        },
        watch :{
            tel(){ 
                    var tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    var mobile = this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.tel=((tel.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    this.required.mobile=((mobile.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    /*
                    this.tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    this.mobile=this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.tel=((this.tel.length>=10)||((this.mobile.length<10)&&(this.tel.length<10)));
                    this.required.mobile=((this.mobile.length>=10)||((this.mobile.length<10)&&(this.tel.length<10)));
                    */
            },
            mobile(){

                    var tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    var mobile = this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.mobile=((mobile.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    this.required.tel=((tel.length>=10)||((mobile.length<10)&&(tel.length<10)));
                    /*
                    this.mobile=this.mobile.toString().replace(/\s|\.|,|-|_/g,'');
                    this.tel=this.tel.toString().replace(/\s|\.|,|-|_/g,'');
                    this.required.mobile=((this.mobile.length>=10)||((this.mobile.length<10)&&(this.tel.length<10)));
                    this.required.tel=((this.tel.length>=10)||((this.mobile.length<10)&&(this.tel.length<10)));
                     */
            },
            title(){
                    this.required.firstname=(this.title=='M.' || this.title=='Mme.'  || this.title==null);
            }
        },
        methods: {
            previous() {
                this.stateForm = 0;
                this.user_selected = null;
            },
            next() {
                this.title = this.user_selected.title;
                this.firstname = this.user_selected.firstname;
                this.lastname = this.user_selected.lastname;
                this.email = this.user_selected.email;
                this.tel = (this.user_selected.tel===null) ? "" : this.user_selected.tel ;
                this.mobile =( this.user_selected.mobile===null )? "" : this.user_selected.mobile ;

              
                this.stateForm = 1;

            },
            add() {
                let data = {
                    link : api.link ,
                    title: this.title,
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email,
                    tel: this.tel,
                    mobile: this.mobile,
                };
                this.axios({url: api.url + 'adherents/' + this.user_selected.id + '?structure_id=' + this.$store.getters.structure_id, data: data, method: 'PUT' })
                    .then(resp => {
                        if(resp.status <400){
                            //console.log(resp.data);
                            this.$router.push("/adherents/index");
                        }
                    })
                    .catch(err => {
                        this.error = true;
                        //console.log(err);
                    });
            },
            check_phone_number: function(event){
                if(event.keyCode < 8 || event.keyCode > 57 || event.keyCode ==13 || event.keyCode ==33 || event.keyCode ==34|| event.keyCode ==35 || event.keyCode ==36 || event.keyCode ==37 || event.keyCode ==38 || event.keyCode ==39 || event.keyCode ==40 || event.keyCode ==41 || event.keyCode ==42 || event.keyCode ==44 || event.keyCode ==45 || event.keyCode ==46 || event.keyCode ==47) event.returnValue = false;
                if( event.which < 8 || event.which > 57 || event.which ==13 || event.which ==33 || event.which ==34 || event.which ==35 || event.which ==36 || event.which ==37 || event.which ==38 || event.which ==39 || event.which ==40 || event.which ==41 || event.which ==42 || event.which ==44 || event.which ==45 || event.which ==46 || event.which ==47) return false;
            },
            check_input: function(event){
                if( event.keyCode < 8 ||  event.keyCode > 122 || event.keyCode==13 || event.keyCode==33 || event.keyCode==34 || event.keyCode==35 || event.keyCode==36 || event.keyCode==37 || event.keyCode==38 || event.keyCode==39 || event.keyCode==40 || event.keyCode==41 || event.keyCode==42 || event.keyCode==43 || event.keyCode==44 || event.keyCode==46 || event.keyCode==47 || event.keyCode==58 || event.keyCode==59 || event.keyCode==60 || event.keyCode==61 || event.keyCode==62 || event.keyCode==63 || event.keyCode==64 || event.keyCode==91 || event.keyCode==92 || event.keyCode==93 || event.keyCode==94 || event.keyCode==96) event.returnValue = false;
                if( event.which < 8 ||  event.which > 122  || event.which==13 || event.which==33 || event.which==34 || event.which==35 || event.which==36 || event.which==37 || event.which==38 || event.which==39 || event.which==40 || event.which==41 || event.which==42 || event.which==43 || event.which==44|| event.which==46 ||  event.which==47 ||  event.which==58 ||  event.which==59 ||  event.which==60 ||  event.which==61 ||  event.which==62 ||  event.which==63 ||  event.which==64 ||  event.which==91 ||  event.which==92 ||  event.which==93 ||  event.which==94 ||  event.which==96) return false;
            },
            
            countDownChanged(dismissCountDown) {
                this.alert.dismissCountDown = dismissCountDown;
            },
            showAlert() {
                this.alert.dismissCountDown = this.alert.dismissSecs;
            },
            open_permission_modal(user) {
                this.$refs.permission_popup.show();
            },
            close_permission_modal(data){
                this.deleteUser=false;
                if(data){
                    this.SetPermission=data.error;

                    if(data.error){
                        this.errormsg=data.errormsg;
                    }
                    
                    if(data.event==2){
                        this.deleteUser=true;
                        this.stateForm = 0;
                    }
                    else{
                        this.deleteUser=false;
                        
                 this.axios({url: api.url + 'utilisateur/' + this.user_selected.id , data: null, method: 'POST' })
                    .then(resp => {
                        if(resp.status <400){
                            this.user_selected=resp.data.user;
                        }
                    })
                    .catch(err => {
                        this.error = true;
                        //console.log(err);
                    });

                    }
                    
                    this.$refs.permission_popup.hide();
                    this.showAlert();
                }
                else {
                    this.$refs.permission_popup.hide();
                }
                
                if(this.deleteUser) {
                            this.user_selected=null;
                        }
            },
        }
    }
</script>

<style scoped>

</style>